import React from "react";
import { useTranslation } from "react-i18next";
import { Check, Trash2 } from "lucide-react";
import { Button } from "../ui/button";
import { Card, CardContent } from "../ui/card";
import { Checkbox } from "../ui/checkbox";
import { getNotificationIcon, getNotificationColor, getPriorityBadge, formatDate } from "./notificationHelpers";

const NotificationCard = ({
  notification, selectedNotifications,
  handleToggleSelection, handleMarkAsRead, handleDeleteNotification,
}) => {
  const { t, i18n } = useTranslation();
  const Icon = getNotificationIcon(notification.notification_type);
  const isUnread = !notification.read_at;

  return (
    <Card className={isUnread ? "border-l-4 border-l-primary bg-primary/5" : ""}>
      <CardContent className="pt-4 pb-4">
        <div className="flex items-start gap-3">
          <Checkbox
            checked={selectedNotifications.includes(notification.id)}
            onCheckedChange={() => handleToggleSelection(notification.id)}
          />

          <div className={`p-2 rounded-full bg-muted ${getNotificationColor(notification.priority)}`}>
            <Icon className="h-4 w-4" />
          </div>

          <div className="flex-1 space-y-1">
            <div className="flex items-start justify-between gap-2">
              <div className="flex-1">
                <p className={`font-medium ${isUnread ? "text-foreground" : "text-muted-foreground"}`}>
                  {notification.title}
                </p>
                <p className={`text-sm ${isUnread ? "text-foreground" : "text-muted-foreground"}`}>
                  {notification.message}
                </p>
              </div>
              <div className="flex items-center gap-2 shrink-0">
                {getPriorityBadge(notification.priority, t)}
                <span className="text-xs text-muted-foreground whitespace-nowrap">
                  {formatDate(notification.created_at, t, i18n.language)}
                </span>
              </div>
            </div>

            {notification.action_url && (
              <Button variant="link" size="sm" className="p-0 h-auto text-blue-600">
                {t("planning.legacy.notifications.actions.viewDetails")}
              </Button>
            )}
          </div>

          <div className="flex items-center gap-1">
            {isUnread && (
              <Button
                variant="ghost"
                size="sm"
                onClick={() => handleMarkAsRead(notification.id)}
                title={t("planning.legacy.notifications.actions.markRead")}
              >
                <Check className="h-4 w-4" />
              </Button>
            )}
            <Button
              variant="ghost"
              size="sm"
              onClick={() => handleDeleteNotification(notification.id)}
              className="text-red-400 hover:text-red-300"
              title={t("common.delete")}
            >
              <Trash2 className="h-4 w-4" />
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default NotificationCard;
